import ru from "@/../public/lang/ru.yaml";
import en from "@/../public/lang/en.yaml";
import fr from "@/../public/lang/fr.yaml";
import es from "@/../public/lang/es.yaml";
import {useStore} from "@/store";

// Список всех локализаций.
export const locales = [
    { code: "ru", name: "Русский" },
    { code: "en", name: "English" },
    { code: "fr", name: "Французский" },
    { code: "es", name: "Испанский" },
];

export function useGlobusLocal(moduleName = "personal_area") {
    const store = useStore();

    function initGlobusLocal(code) {
        setLocale(code).then();
    }

    async function setLocale(code) {
        if (store.language !== code) {
            store.language = locales.find((l) => l.code === code);
            localStorage.setItem("globusLanguage", code);
            const event = new CustomEvent("ChangeLanguage", { detail: {code: code} });
            window.dispatchEvent(event);
        }
    }

    function t(path, ...args) {
        const code = store.language.code;
        const base = (
            window.globusDictionary?.[code]?.view?.[moduleName]
        ) ?? {};
        
        const keys = path.split(".");
        let str = keys.reduce((obj, key) =>
                (obj != null && key in obj) ? obj[key] : undefined
            , base);

        if (typeof str !== "string") {
            str = path;
        }

        for (const arg of args) {
            str = str.replace("%s", arg);
        }

        return str;
    }

    return {
        t,
        initGlobusLocal,
        setLocale,
    };
}

export const t = (path, ...args) => useGlobusLocal().t(path, ...args);

// Экспорт локализаций в объект window
window.globusDictionary = {
    ...ru,
    ...en,
    ...es,
    ...fr
};

// Экспорт функции перевода
window.useGlobusLocal = (moduleName) => useGlobusLocal(moduleName).t;
